import React from 'react';
import { ArServiceContextProvider } from './AccountsReceivableServiceContext';
import DepositReconciliationPage from './DepositReconciliationPage';
const DepositReconciliationComponent = () => {
  return (
    <ArServiceContextProvider>
      <DepositReconciliationPage />
    </ArServiceContextProvider>
  );
};
export default DepositReconciliationComponent;


// WEBPACK FOOTER //
// ./src/components/accounts-receivable/DepositReconciliationComponent.tsx